// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--YUQ1I";